import { unwrapResult } from '@reduxjs/toolkit';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TrashBinIcon } from '@rsos/assets/icons';
import { Box, Button, Text } from '@rsos/components/capstone/base';
import { ACTIVE } from '@rsos/constants/peerAgenciesStatuses';
import {
  removeAgency,
  removeAgencyLinksTo,
} from '@rsos/reduxDataStore/src/features/peerAgencies/peerAgenciesSlice';
import { notifyError } from '@rsos/utils/toastUtils';
import { agencyStatusMap } from '../../utils/helpers';
import { TableRow, IconWrapper } from './LinksToTable.styles';

const LinksToRow = () => {
  const dispatch = useDispatch();
  const { sinatra } = useSelector(state => state);
  const org = sinatra.user.currentOrg.name;
  const agencyLinksTo = useSelector(
    state => state.peerAgencies.agencyLinks.linksTo,
  );

  const handleRemoveAgency = id => {
    const data = {
      org,
      id,
    };
    dispatch(removeAgency(data))
      .then(unwrapResult)
      .then(() => dispatch(removeAgencyLinksTo(id)))
      .catch(error => {
        notifyError(error);
      });
  };

  return agencyLinksTo && agencyLinksTo.length ? (
    agencyLinksTo.map(agency => (
      <TableRow key={agency.id}>
        <Box width="50%">
          <Text
            color={agency.status === ACTIVE ? 'primaryText' : 'secondaryText'}
            data-name="links-to-agency-name"
            ellipsis
            size="normal"
          >
            {agency.link_to.display_name}
          </Text>
        </Box>
        <Box width="25%">
          <Text
            color={agency.status === ACTIVE ? 'primaryText' : 'secondaryText'}
            data-name="links-to-agency-status"
            size="normal"
          >
            {agencyStatusMap(agency.status)}
          </Text>
        </Box>
        <Box width="25%" align="flex-end">
          <Button
            btnType="invisible"
            dataName="remove-agency-button"
            noMargin
            onClick={() => handleRemoveAgency(agency.id)}
            size="small"
            style={{ width: '35px' }}
          >
            <IconWrapper>
              <TrashBinIcon
                width={25}
                height={25}
                viewboxWidth={140}
                viewboxHeight={140}
              />
            </IconWrapper>
          </Button>
        </Box>
      </TableRow>
    ))
  ) : (
    <Text color="secondaryText" data-name="no-peer-agencies">
      There are no peer agencies.
    </Text>
  );
};

export default LinksToRow;
